<template>
  <div class="responses container">
    <form v-if="!list" novalidate @submit.prevent="access">
      <div class="input-group">
        <input type="password" class="form-control" name="password" placeholder="código de acesso" v-model="password">
        <span class="input-group-btn">
          <button class="btn btn-secondary" type="submit">Acessar</button>
        </span>
      </div>
    </form>
    <table v-else class="table">
      <thead>
        <tr>
          <th>Nome</th>
          <th style="width: 160px">e-mail</th>
          <th style="width: 520px" class="text-center">Empresa</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, i) in list" :key="i" v-bind:class="{ legacy: entry.legacy }">
          <th scope="row"><a :href="`mailto:${entry.email}`">{{entry.name}}</a></th>
          <td>{{entry.email}}</td>
          <td class="text-center">{{entry.empresa}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faAndroid from '@fortawesome/fontawesome-free-brands/faAndroid';
import faApple from '@fortawesome/fontawesome-free-brands/faApple';
import faQuestion from '@fortawesome/fontawesome-free-solid/faQuestion';

import { API_URL } from '../config';

const options = (list) => list.map((e) => ({label: e, value: e}));

export default {
  name: 'register',
  data: () => ({
    tries: 0,
    password: '',
    list: false,
  }),
  components: {
    FontAwesomeIcon,
  },
  methods: {
    access() {
      if (!this.password) {
        return;
      }

      this.tries += 1;
      if (this.tries > 5) {
        return;
      }

      this.getList()
        .then((result) => {
          this.list = result.body.filter(e => e.empresa)
        })
        .catch(() => {});
    },
    getList() {
      const url = `${API_URL}/list?password=${this.password}`;
      return this.$http.get(url);
    },
    getIcon(platform) {
      const icons = {
        android: faAndroid,
        ios: faApple,
      };
      return icons[platform] || faQuestion;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #FFFDE4;
}

.responses table {
  color: #ffffff;
}

.responses .legacy {
  opacity: 0.4;
}

.icon-cell {
  font-size: 1.4em;
  padding: 0.3em 0.75rem;
}
</style>



// WEBPACK FOOTER //
// Responses.vue?843972e4